function initFormErrorClearing() {
  document.querySelectorAll(".FormElement--error").forEach((wrapper) => {
    function clear() {
      wrapper.classList.remove("FormElement--error")
      wrapper
        .querySelectorAll(".FormElement__error")
        .forEach((el) => el.remove())
    }

    wrapper.querySelectorAll("select").forEach((select) => {
      const handler = () => {
        if (!select.value) {
          return
        }

        clear()

        select.removeEventListener("change", handler)
      }

      select.addEventListener("change", handler)
    })

    wrapper
      .querySelectorAll(
        "input[type='text'], input[type='email'], input[type='tel'], " +
          "input[type='number'], input[type='url'], input[type='search'], textarea",
      )
      .forEach((input) => {
        input.addEventListener("input", clear, { once: true })
      })

    const fileList = wrapper.querySelector(".file-attachment__list")

    if (fileList) {
      const observer = new MutationObserver((mutations) => {
        const added = mutations.some((m) =>
          Array.from(m.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList?.contains("file-attachment__file-info"),
          ),
        )

        if (added) {
          observer.disconnect()
          clear()
        }
      })
      observer.observe(fileList, { childList: true })
    }
  })
}

document.addEventListener("DOMContentLoaded", initFormErrorClearing)
